export default __webpack_public_path__ + "static/go-live-a7e46980d90a0eb951725b052416dfcf.png";